import { Fragment, h, render } from "preact";
import { FreeMode, Mousewheel } from "swiper/modules";

const BundleUpsellContent = ({ data, product }) => {
  let bundleProduct;
  try {
    bundleProduct = product?.textContent
      ? JSON.parse(product?.textContent)
      : null;
  } catch (error) {
    bundleProduct = null;
  }

  if (!bundleProduct) return;
  const swiperParams = {
    slidesPerView: bundleProduct.length == 1 ? 1 : 1.33,
    spaceBetween: bundleProduct.length == 1 ? 1 : 16,
    effect: "fade",
    fadeEffect: { crossFade: true },
    rebuildOnUpdate: true,
    mousewheel: {
      forceToAxis: true,
    },
  };

  const getRelatedImage = (item) => {
    let image_src = item.bundle_product.featured_image
      ? item.bundle_product.featured_image
      : item?.bundle_product?.images?.edges
        ? item?.bundle_product?.images?.edges[0].node.src
        : null;

    return (
      image_src && (
        <img
          src={getSizedImageUrl(image_src, "small")}
          alt={item.bundle_product.title}
          width="120"
          height="120"
        />
      )
    );
  };

  return (
    bundleProduct && (
      <Fragment>
        <span className="h5">Complete Your Bundle</span>
        <swiper-container
          {...swiperParams}
          modules={[FreeMode, Mousewheel]}
          className="related-products__container"
        >
          {bundleProduct.map((item, index) => (
            <swiper-slide className="swiper-slide">
              <div className="product-form__option">
                <a
                  href={
                    item.bundle_product.url
                      ? item.bundle_product.url
                      : `/products/${item.bundle_product.handle}?p=${item.product.variant_id}`
                  }
                >
                  <label>
                    <div className="product-form__option-text">
                      <span>{item.bundle_product.title}</span>
                      <span className="product-form__option-price">
                        {window.formatMoney(
                          item.bundle_product.price
                            ? item.bundle_product.price / 100
                            : null,
                        )}
                      </span>
                      <span
                        className="product-form__option-availability caption-small"
                        data-stock
                      >
                        {item?.bundle_product?.variants &&
                        item?.bundle_product?.variants[0]?.available
                          ? "In Stock"
                          : item?.bundle_product?.variants?.edges &&
                              item?.bundle_product?.variants?.edges[0]?.node
                                .availableForSale
                            ? "In Stock"
                            : ""}
                      </span>
                    </div>
                    <div className="product-form__option-image">
                      {getRelatedImage(item)}
                    </div>
                  </label>
                </a>
              </div>
            </swiper-slide>
          ))}
        </swiper-container>
      </Fragment>
    )
  );
};

export default BundleUpsellContent;
